import { render, staticRenderFns } from "./AllowlistRegistration.vue?vue&type=template&id=4c747f31&scoped=true"
import script from "./AllowlistRegistration.vue?vue&type=script&lang=js"
export * from "./AllowlistRegistration.vue?vue&type=script&lang=js"
import style0 from "./AllowlistRegistration.vue?vue&type=style&index=0&id=4c747f31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c747f31",
  null
  
)

export default component.exports